<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body mx-3">
  <span class="fw-bold fs-3" *ngIf="modalType === 'edit'"
    >{{ "forms.edit_coupon_user_info" | translate }}</span
  >
  <span class="fw-bold fs-3" *ngIf="modalType === 'new'"
    >{{ "forms.new_coupon_user_info" | translate }}</span
  >
  <div class="w-100">
    <form [formGroup]="couponUserInfoForm">
      <div
        class="d-flex flex-column align-items-center justify-content-center w-100 gap-4 py-4"
      >
        <!-- <div class="d-flex w-100 gap-2">
          <div class="w-50">
            <label class="form-label">{{ "forms.name" | translate }}</label>
            <input type="text" class="form-control" formControlName="name" />
          </div>
          <div class="w-50">
            <label class="form-label">{{ "forms.surname" | translate }}</label>
            <input type="text" class="form-control" formControlName="surname" />
          </div>
        </div>

        <div class="d-flex w-100 gap-2">
          <div class="w-50">
            <label class="form-label">{{ "forms.email" | translate }}</label>
            <input type="text" class="form-control" formControlName="email" />
          </div>
          <div class="w-50">
            <label class="form-label">{{ "forms.telephone" | translate }}</label>
            <input type="text" class="form-control" formControlName="phone" />
          </div>
        </div>

        <div class="d-flex w-100 gap-2">
          <div class="w-50">
            <label class="form-label">{{ "participants.role" | translate }}</label>
              <ng-select
                [items]="professionOptions"
                [bindValue]="'id'"
                [bindLabel]="'name'"
                formControlName="profession"
              ></ng-select>
          </div>
          <div class="w-50">
            <label class="form-label">{{ "forms.city" | translate }}</label>
            <input type="text" class="form-control" formControlName="city" />
          </div>
        </div> -->
        <div class="w-100 text-start mt-3">
          <span class="fw-bold fs-4"
            >{{ "collections.register_new_sale" | translate }}</span
          >
        </div>
        <div
          [formArrayName]="'sales'"
          class="d-flex flex-column align-items-center justify-content-center w-100 gap-4 py-2"
        >
          @for (sale of salesFormArray.controls; track sale) {
          <div [formGroupName]="$index" class="box-project w-100">
            <div class="d-flex align-items-center justify-content-between">
              <div>#{{ $index + 1 }}</div>
              <i
                class="fa fa-trash"
                style="cursor: pointer"
                (click)="removeSale($index)"
              ></i>
            </div>
            <div class="mt-2 w-100 d-flex gap-2">
              <div class="w-75">
                <label class="form-label" for="quantity"
                  >{{ "collections.purchases" | translate }}</label
                >
                <ng-select
                  [items]="salesOptions"
                  [bindValue]="'code'"
                  [bindLabel]="'name'"
                  formControlName="code"
                  (change)="onOptionSelected($event)"
                ></ng-select>
              </div>
              <div class="w-25">
                <label class="form-label" for="quantity"
                  >{{ "forms.mq" | translate }}</label
                >
                <input
                  type="text"
                  class="form-control w-100"
                  formControlName="quantity"
                  placeholder="0"
                  (input)="onQuantityInput($event, sale.get('quantity'))"
                />
              </div>
            </div>
          </div>
          }
        </div>
        <div class="form-group w-100 text-end">
          <a
            data-test="add-new-product"
            class="link text-decoration-underline"
            style="cursor: pointer"
            (click)="addNewProduct()"
            >{{ 'collections.add_new_product' | translate }}</a
          >
        </div>

        <div
          class="w-100 mt-3 d-flex align-items-center justify-content-start gap-3"
        >
          <button
            class="btn btn-primary"
            [disabled]="!couponUserInfoForm.valid"
            (click)="saveCouponInfo()"
          >
            {{ "button_labels.save_close" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
